/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<circle pid="0" cx="8" cy="8" r="8"/><g _stroke="#c7ccd1" stroke-width="2" stroke-linecap="round"><path pid="1" d="M5 5l6 6M5 11l6-6"/></g>'
  }
})
